import { render, staticRenderFns } from "./ImgCaptcha.vue?vue&type=template&id=4e79053c&"
import script from "./ImgCaptcha.vue?vue&type=script&lang=js&"
export * from "./ImgCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports